export const isArchiveBattle = battle => (battle?.fightDesc || '').startsWith('飞书获奖档案｜');

export const historyThumbnail = url => url?.includes('/history/feishu-20260922/')
  ? url.replace(/-1600\.webp$/, '-480.webp') : url;

let catalogRequest;
export async function attachArchiveTitles(battle) {
  if (!isArchiveBattle(battle)) return battle;
  if (!catalogRequest) {
    catalogRequest = fetch('/history/feishu-20260922/catalog.json')
      .then(response => { if (!response.ok) throw new Error('作品标题读取失败'); return response.json(); })
      .catch(error => { catalogRequest = null; throw error; });
  }
  try {
    const catalog = await catalogRequest;
    const enrich = creation => {
      const key = creation.creationUrl?.split('/').pop()?.replace(/-1600\.webp$/, '');
      return { ...creation, archiveTitle: catalog.items?.[key]?.title || '获奖作品' };
    };
    return { ...battle, winnerList: (battle.winnerList || []).map(enrich), creationList: (battle.creationList || []).map(enrich) };
  } catch (_) { return battle; }
}
